import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appFocusable]',
})
export class AppFocusableDirective {

  @Output() public onFocusChange = new EventEmitter();

  @HostListener('focus', ['$event.target'])
  public onFocus(): void {
    this.onFocusChange.emit(true);
  }

  @HostListener('blur', ['$event.target'])
  public onBlur(): void {
    this.onFocusChange.emit(false);
  }
}
